// extracted by mini-css-extract-plugin
export default {"wrapper":"ea","center":"fa"};